// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"193":"unauthorized","238":"forbidden","472":"settings"}[chunkId] + "." + {"193":"d6fab205","238":"a8f96b27","472":"d3676317"}[chunkId] + ".css";
};